import {graphql} from "gatsby";
import * as React from "react";
import SolutionPageLayout from "../../components/Solution/PageLayout";
import * as pageStyles from "./solution-page.module.css";

const styles = {
    page: pageStyles.solutionPage,
    content: pageStyles.solutionPage__content,
    faq: pageStyles.solutionPage__faq,
};

const SolutionPage = ({data: {solution}}) => {
    return <SolutionPageLayout data={solution} styles={styles} />;
};

export const pageQuery = graphql`
    query ($id: String) {
        solution: strapiSolutions(id: {eq: $id}) {
            seo {
                title
                description
                openGraph {
                    title
                    description
                    image {
                        url
                    }
                }
            }
            title
            description
            freeDaysCount
            heroVariant
            heroMedia {
                youtubeVideoURL
                content {
                    mime
                    width
                    height
                    localFile {
                        publicURL
                        childImageSharp {
                            gatsbyImageData(placeholder: NONE)
                        }
                    }
                }
            }
            contentTitle
            content {
                id
                title
                description
                type
                appStoreURL
                googlePlayURL
                buttonText
                buttonLink
                item {
                    id
                    title
                    description
                    media {
                        id
                        youtubeVideoURL
                        content {
                            mime
                            width
                            height
                            localFile {
                                publicURL
                                childImageSharp {
                                    gatsbyImageData(placeholder: NONE)
                                }
                            }
                        }
                    }
                }
                media {
                    id
                    youtubeVideoURL
                    content {
                        mime
                        width
                        height
                        localFile {
                            publicURL
                            childImageSharp {
                                gatsbyImageData(placeholder: NONE)
                            }
                        }
                    }
                }
            }
            capabilities {
                title
                enabled
                items {
                    id
                    title
                    description
                    icon {
                        mime
                        width
                        height
                        localFile {
                            childImageSharp {
                                gatsbyImageData(placeholder: NONE)
                            }
                        }
                    }
                }
            }
            slider {
                title
                items {
                    id
                    title
                    list {
                        id
                        text
                    }
                    photo {
                        width
                        mime
                        height
                        localFile {
                            childImageSharp {
                                gatsbyImageData(placeholder: NONE)
                            }
                        }
                    }
                }
            }
            feature {
                title
                description
                buttonText
                buttonLink
                videoFrame
                list {
                    id
                    text
                }
            }
            advantages {
                title
                cards {
                    id
                    title
                    description
                }
            }
            articles {
                title
                articles {
                    id
                    title
                    description
                    readingTime
                    published_at
                    slug
                    featuredImage {
                        width
                        mime
                        height
                        localFile {
                            childImageSharp {
                                gatsbyImageData(width: 632)
                            }
                        }
                    }
                }
            }
            tariffs {
                title
                tariffs {
                    id
                    title
                    frontendTitle
                    description
                    price
                    freeLicenseCount
                    isPopular
                    discount {
                        enabled
                        text
                    }
                }
            }
            faq {
                title
                items {
                    id
                    answer
                    question
                }
            }
        }
    }
`;

export default SolutionPage;
